/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientStatusHistory
 */
export interface ClientStatusHistory {
    /**
     * 
     * @type {Date}
     * @memberof ClientStatusHistory
     */
    timestamp: Date;
    /**
     * 
     * @type {string}
     * @memberof ClientStatusHistory
     */
    status: string;
}

/**
 * Check if a given object implements the ClientStatusHistory interface.
 */
export function instanceOfClientStatusHistory(value: object): value is ClientStatusHistory {
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ClientStatusHistoryFromJSON(json: any): ClientStatusHistory {
    return ClientStatusHistoryFromJSONTyped(json, false);
}

export function ClientStatusHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientStatusHistory {
    if (json == null) {
        return json;
    }
    return {
        
        'timestamp': (new Date(json['timestamp'])),
        'status': json['status'],
    };
}

export function ClientStatusHistoryToJSON(json: any): ClientStatusHistory {
    return ClientStatusHistoryToJSONTyped(json, false);
}

export function ClientStatusHistoryToJSONTyped(value?: ClientStatusHistory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timestamp': value['timestamp'].toISOString(),
        'status': value['status'],
    };
}

